import React, { useEffect, useCallback, useState } from "react";
import { fetchCollectionAction } from "state/actions/collectionActions";
import {
  REWARDS,
  REWARDS_ITEM_LOCATION,
  REWARDS_CATEGORY,
} from "state/constants/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  requestRewards,
  requestItemLocation,
  requestCategory,
} from "apis/rewards";
import { getRewards } from "../apis/middlewareEndpoints";
import { getItemLocation } from "apis/middlewareEndpoints";
import RewardLandingPage from "../components/Reward";
import Async from "components/Async/Async";
import { navigate } from "gatsby";
import { getRewardCategories } from "../apis/middlewareEndpoints";
import { useAuth0 } from "@auth0/auth0-react";

const Rewards = ({ ...props }) => {
  const defaultPerPage = 10;
  const requestUrl = props.params.substring(props.params.indexOf("?") + 1);
  const arrayParamsUrl =
    requestUrl != ""
      ? JSON.parse(
        '{"' + requestUrl.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
        function (key, value) {
          return key === "" ? value : decodeURIComponent(value);
        }
      )
      : [];
  const defaultPage =
    arrayParamsUrl.page != undefined ? arrayParamsUrl.page : "1";
  const [currentPage, setCurrentPage] = useState(defaultPage);
  const defaultMinPoint =
    arrayParamsUrl.min_price != undefined ? arrayParamsUrl.min_price : "";
  const [minPoint, setMinPoint] = useState(defaultMinPoint);
  const defaultMaxPoint =
    arrayParamsUrl.max_price != undefined ? arrayParamsUrl.max_price : "";
  const [maxPoint, setMaxPoint] = useState(defaultMaxPoint);
  const defaultLocation =
    arrayParamsUrl.property != undefined ? arrayParamsUrl.property : "";
  const [currentLocation, setCurrentLocation] = useState(defaultLocation);
  const defaultCategory =
    arrayParamsUrl.category_id != undefined ? arrayParamsUrl.category_id : "";
  const [currentCategory, setCurrentCategory] = useState(defaultCategory);
  const [isChangeRange, setIsChangeRange] = useState(false);
  const onChangeRange = () => {
    setCurrentPage("1");
    setIsChangeRange(!isChangeRange);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };
  const [rewardsItemLocation, setRewardsItemLocation] = useState([]);
  const isAuth0Enabled = process.env.GATSBY_ENABLE_AUTH0 === "true";

  const { collection: rewards, uiState, error } = useSelector(
    (state) => state.rewards
  );

  const {
    collection: rewards_category,
    uiStateCategory,
    errorCategory,
  } = useSelector((state) => state.rewards_category);

  const excludedCategoryIds = (process.env.GATSBY_EXCLUDED_CATEGORY_IDS || "")
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean)
    .map(Number);

  const dispatch = useDispatch();
  useEffect(() => {
    if (isAuth0Enabled) {
      const fetchItemsLocation = async () => {
        const response = await getItemLocation("redemption");
        setRewardsItemLocation(response.data);
      };
      fetchItemsLocation();
    } else {
      fetchCollectionAction(
        REWARDS_ITEM_LOCATION,
        dispatch,
        requestItemLocation
      );
    }
    fetchCollectionAction(
      REWARDS_CATEGORY,
      dispatch,
      process.env.GATSBY_ENABLE_AUTH0 === "true"
        ? getRewardCategories
        : requestCategory
    );
  }, [isAuth0Enabled]);

  useEffect(() => {
    window.history.pushState(
      {},
      "",
      "?page=" +
      (currentPage ? currentPage : 1) +
      (minPoint != "" ? "&min_price=" + minPoint : "") +
      (maxPoint != "" ? "&max_price=" + maxPoint : "") +
      (currentLocation != "" ? "&property=" + currentLocation : "") +
      (currentCategory != "" ? "&category_id=" + currentCategory : "")
    );

    fetchCollectionAction(REWARDS, dispatch, getRewards, {
      page: currentPage,
      min_price: minPoint,
      max_price: maxPoint,
      category_id: currentCategory,
      property: currentLocation,
      lang: props.langKey,
    });
  }, [currentPage, isChangeRange, currentLocation, currentCategory]);

  const {
    isAuthenticated
  } = useAuth0();

  const guestInformation = useSelector(
    (store) => store.guestInformation.member.data
  );

  return (
    <Async
      uiState={uiState}
      error={error}
      onSuccess={() => (
        <>
          <RewardLandingPage
            props={props}
            isLogin={isAuthenticated ? true : false}
            userInfomration={guestInformation ? guestInformation : null}
            rewards={rewards}
            rewards_item_location={rewardsItemLocation}
            rewards_category={rewards_category}
            excludedCategoryIds={excludedCategoryIds}
            loginUrl={props.loginUrl}
            redemptionUrl={props.redemptionUrl}
            langData={props.langData}
            currentPage={currentPage}
            minPoint={minPoint}
            maxPoint={maxPoint}
            currentLocation={currentLocation}
            currentCategory={currentCategory}
            setCurrentPage={setCurrentPage}
            setMinPoint={setMinPoint}
            setMaxPoint={setMaxPoint}
            setCurrentLocation={setCurrentLocation}
            setCurrentCategory={setCurrentCategory}
            onChangeRange={onChangeRange}
            langKey={props.langKey}
          />
        </>
      )}></Async>
  );
};

export default Rewards;
